<template>
  <FormSelect
    label="Store"
    :values="values"
    :options="options"
    :rules="[VALIDATION.requiredArray]"
    :loading="loading"
    :disable="loading || disabled"
    :multiple="multiple"
    @updateStore="onUpdateStore"
  />
</template>

<script>
import { ref, inject, watch, onBeforeMount } from 'vue'
import { FormSelect } from '@/components/inputs'
import { VALIDATION, Toast, fetchData } from '@/tools'

export default {
  name: 'SelectUserStores',
  inheritAttrs: true,
  emits: ['updateStore'],
  components: {
    FormSelect
  },
  props: {
    values: {
      type: [String, Number, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    area: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const { data, error, loading, get, post } = fetchData()
    const { showToast } = Toast()
    const options = ref([])
    const state = inject('store')?.state

    const onUpdateStore = data => {
      emit('updateStore', data)
    }

    const getStores = () => {
      if (props.area) {
        get(`v1/user/me?area_id=${props.area}`)
      } else {
        const payload = {
          filters: {
            retailer: state?.profile?.retailer_id
          }
        }
        post('v1/stores', payload)
      }
    }

    watch(
      () => props.area,
      () => {
        getStores()
      }
    )

    onBeforeMount(() => {
      getStores()
      watch([data, error, loading], () => {
        if (!loading.value) {
          if (error?.value) {
            showToast('There was a problem fetching stores.', 'danger')
          } else if (data?.value) {
            options.value = data?.value?.store_access?.map(item => ({
              label: item?.name,
              value: item?.id
            }))
          }
        }
      })
    })

    return { options, loading, VALIDATION, onUpdateStore }
  }
}
</script>
